/* eslint-disable react/prop-types */
import React, {
  useState,
  useEffect,
  useRef,
} from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Col,
  Card,
  Spin,
  Button,
  Input,
  message,
  Row,
  Typography,
  DatePicker,
  Modal,
} from 'antd';
import {
  DeleteOutlined,
  ArrowLeftOutlined,
  SaveOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  EditOutlined,
  ReloadOutlined,
  RollbackOutlined,
} from '@ant-design/icons';
import InputSearch from 'components/InputSearch';
import Table from 'components/Table';
import Select from 'components/Select';
import LadaNumero from 'components/LadaNumero';
import FormSubmitCustomControls from 'components/FormSubmitCustomControls';
import toCurrency from 'utils/toCurrency';
import { onError } from 'utils/handlers';
import { getCatalogoDePadrones } from 'api/catalogos';
import {
  getTiposDeAplicacionParaCargos,
  getTiposDeVehiculos,
  getServiciosDelVehiculo,
} from 'api/recaudacion/index';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { patchCiudadano } from 'api/cuentaunicasir/ciudadanos';
import { getTipoDeCargo } from 'api/recaudacion/tiposDeCargo';
import { getMonedas } from 'api/configuracion';
import { getMotivosDeCancelacionDeCargo } from 'api/catalogos/motivosDeCancelacionDeCargo';
import { DATETIME_FORMAT, DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import ModalAgregarCargos from 'views/Recaudacion/Caja/ModalAgregarCargos';
import {
  getCargo,
  getCargosPaginados,
  patchCargo,
  postReactivarCargos,
} from 'api/recaudacion/cargos';
import { ESTADOS_GLOBALES_MAP, isMutable, isSpecific } from 'utils/estadosGlobales';
import NumericInput from 'components/NumericInput';
import {
  ciudadanoToString,
  contribuyenteToString,
  empresaToString,
  infraccionesToString,
  mercadosToString,
  panteonToString,
  predioToString,
  restoDePadronesToString,
  vehiculoToString,
} from 'utils/padronesToString';
import { capitalize } from 'utils/normalizers';
import round from 'utils/round';
import { sortCargos } from 'utils/cargos';
import {
  getContenTypePorTipoDePadron,
  getHelpTexts,
  gettersPadronesCajaMap,
} from 'utils/padrones';
import Editor from 'components/Editor';
import { aplicacionesCargosEnum, padronesEnum } from 'views/Tramites/GPM/enums';
import ModalAlertas from 'views/Recaudacion/Caja/ModalAlertas';
import Moment from 'moment';
import InfoPadron, { avilablePadrones } from 'components/PadronesInfo';

const { Title } = Typography;

const filters = {
  1: (e) => e,
  2: (e) => e.saldado,
  3: (e) => (!e.saldado && e.estados_globales !== ESTADOS_GLOBALES_MAP.CANCELADO),
  4: (e) => e.estados_globales === ESTADOS_GLOBALES_MAP.CANCELADO,
};

const options = [
  {
    id: 1,
    descripcion: 'Todos',
  },
  {
    id: 2,
    descripcion: 'Saldados',
  },
  {
    id: 3,
    descripcion: 'Sin Saldar',
  },
  {
    id: 4,
    descripcion: 'Cancelados',
  },
];

const Cargos = ({ permission }) => {
  const usuario = useSelector(({ auth }) => auth.user);
  const _entidad = useSelector(({ auth }) => auth.entidad);
  const { padron_principal } = _entidad;
  const padrones = useSelector(({ catalogs }) => catalogs.padrones)?.filter((e) => e.id !== 5);
  const estadosGlobales = useSelector(({ catalogs }) => catalogs.estadosGlobales);
  const [form] = Form.useForm();
  const [formCargo] = Form.useForm();
  const [formCancel] = Form.useForm();
  const [formFiltros] = Form.useForm();
  const [formDescuento] = Form.useForm();
  const seleccionUnica = Form.useWatch('seleccionUnica', formFiltros);
  const seleccionPrevios = Form.useWatch('seleccionPrevios', formFiltros);
  const [loading, setLoading] = useState(false);
  const [tipoDePadronSelected, setTipoDePadronSelected] = useState(padron_principal
    || padronesEnum.CIUDADANO);
  const [cargos, setCargos] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleBusquedaPadrones, setVisibleBusquedaPadrones] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataExterno, setDataExterno] = useState([]);
  const [padron, setPadron] = useState(null);
  const [monedas, setMonedas] = useState([]);
  const [motivosDeCancelacion, setMotivosDeCancelacion] = useState([]);
  const [visibleModalCargos, setVisibleModalCargos] = useState(false);
  const [visibleCancel, setVisibleCancel] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [mutable, setMutable] = useState(true);
  const [current, setCurrent] = useState(null);
  const [recalcular, setRecalcular] = useState(false);
  const [disableImporteField, setDisableImporteField] = useState(false);
  const [currentTipoDeCargo, setCurrentTipoDeCargo] = useState(null);
  const [serviciosVehiculares, setServiciosVehiculares] = useState([]);
  const [tiposDeVehiculos, setTiposDeVehiculos] = useState([]);
  const [restrict, setRestrict] = useState(false);

  const cargosFilter = useRef([]);

  const normalizeCargos = (_cargos) => _cargos.map((item) => {
    const {
      descuentos_aplicables,
      descuentos_especiales,
      actualizaciones,
      recargos,
      gastos: _gastos,
    } = item;
      // Totales por concepto
    const recargo_total = recargos
      .reduce((accum, curr) => accum + (curr.importe_total * 1000), 0) / 1000 || 0;
    const gasto_total = _gastos
      .reduce((accum, curr) => accum + (curr.importe * 1000), 0) / 1000 || 0;
    const actualizacion_total = actualizaciones
      .reduce((accum, curr) => accum + (curr.importe_total * 1000), 0) / 1000 || 0;
      // Descuentos
    const descuentosRecargos = recargos
      .reduce((accum, curr) => accum.concat(curr.descuentos), []);
    const descuentosActualizaciones = actualizaciones
      .reduce((accum, curr) => accum.concat(curr.descuentos), []);
    const descuentosGastos = _gastos
      .reduce((accum, curr) => accum.concat(curr.descuentos), []);
    const descuento_total = descuentos_especiales
      .concat([
        ...descuentos_aplicables,
        ...descuentosRecargos,
        ...descuentosActualizaciones,
        ...descuentosGastos,
      ])
      .reduce((accum, curr) => accum + (curr.importe_total * 1000), 0) / 1000 || 0;

    const importe_total = round(item.importe - descuento_total + recargo_total
        + gasto_total + actualizacion_total);
    return {
      ...item,
      key: item.id,
      descuento_total,
      actualizacion_total,
      recargo_total,
      importe_total: Math.max(0, importe_total),
      gasto_total,
      cargoPadre: _cargos.find((e) => e.id === item?.cargo_padre),
    };
  });

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _monedas,
        _servicios,
        _tiposDeVehiculos,
        _tiposDeAplicacion,
        _catalogoDePadrones,
        _motivosDeCancelacion,
      ] = await Promise.all([
        getMonedas(),
        getServiciosDelVehiculo(),
        getTiposDeVehiculos(),
        getTiposDeAplicacionParaCargos(),
        getCatalogoDePadrones(),
        getMotivosDeCancelacionDeCargo(),
      ]);
      if (mounted) {
        setMonedas(_monedas);
        setServiciosVehiculares(_servicios);
        setTiposDeVehiculos(_tiposDeVehiculos);
        setMotivosDeCancelacion(_motivosDeCancelacion);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const columns = [
    {
      titleText: 'Periodo',
      dataIndex: 'tipo_de_cargo',
      key: 'tipo_de_cargo',
      width: 200,
      render: ({ periodo_fiscal }) => periodo_fiscal?.periodo || '',
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 500,
    },
    {
      titleText: 'Importe Base',
      dataIndex: 'importe',
      key: 'importe',
      width: 150,
      align: 'right',
      render: (val) => toCurrency(val || 0),
    },
    {
      titleText: 'Moneda',
      dataIndex: 'moneda',
      key: 'moneda',
      width: 300,
      render: (val) => monedas.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Fecha de Vencimiento',
      dataIndex: 'fecha_de_vencimiento',
      key: 'fecha_de_vencimiento',
      width: 200,
      render: (val) => (val || 'No aplica'),
    },
    {
      titleText: 'Importe Total',
      dataIndex: 'importe_total',
      key: 'importe_total',
      align: 'right',
      width: 200,
      render: (val) => toCurrency(val || 0),
    },
    {
      titleText: 'Saldado',
      dataIndex: 'saldado',
      key: 'saldado',
      width: 150,
      render: (e) => (e ? 'Sí' : 'No'),
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 170,
      render: (eg, record) => {
        if (record.cancelado) {
          return 'Cancelado';
        }
        return estadosGlobales.find((e) => e.id === eg)?.descripcion;
      },
    },
  ];

  const onClickEdit = async (id) => {
    if (restrict) {
      message.warn('Este padrón tiene alertas restrictivas, no es posible modificar el cargo.');
      return;
    }

    setLoading(true);
    const key = id ?? selectedRowKeys[0];
    const _cargo = await getCargo(key);
    const _tipoDeCargo = await getTipoDeCargo(_cargo.tipo_de_cargo.id);
    let importe_total = 0;
    if (_tipoDeCargo.tipo_de_aplicacion === aplicacionesCargosEnum.FIJO) {
      importe_total = _tipoDeCargo.importe;
    } else if (_tipoDeCargo.tipo_de_aplicacion === aplicacionesCargosEnum.MULTIPLO) {
      importe_total = _cargo.cantidad_multiplo;
    } else if ([aplicacionesCargosEnum.FORMULA, aplicacionesCargosEnum.CAPTURABLE]
      .includes(_tipoDeCargo.tipo_de_aplicacion)) {
      importe_total = _cargo.importe_de_moneda;
    } else {
      importe_total = _cargo.importe_total;
    }
    const formula = [aplicacionesCargosEnum.FORMULA, aplicacionesCargosEnum.SQL_FUNCTION]
      .includes(_tipoDeCargo.tipo_de_aplicacion) ? _tipoDeCargo.formula : '';

    const _formValues = {
      ..._tipoDeCargo,
      ..._cargo, // Datos del Cargo
      clave: _tipoDeCargo.clave, // Datos del Tipo de Cargo
      moneda: _tipoDeCargo.moneda, // Datos del Tipo de Cargo
      fecha_de_creacion: _tipoDeCargo?.fecha_de_creacion, // Datos del Tipo de Cargo
      imprimir_observaciones: _tipoDeCargo.imprimir_observaciones, // Datos del Tipo de Cargo
      fecha_de_vencimiento: _cargo.fecha_de_vencimiento, // Datos del Tipo de Cargo
      importe_total, // Datos del Tipo de Cargo
      formula,
    }; // 4112100001-21-01

    const _mutable = isSpecific(_formValues) && !_tipoDeCargo.no_cargar_manualmente;
    // bandera para saber si se puede cambiar el importe
    const canEditCantidad = _tipoDeCargo.moneda === 1
    && !_cargo.actualizaciones.length
    && !_cargo.descuentos_aplicables.length
    && !_cargo.descuentos_especiales.length
    && !_cargo.gastos.length
    && !_cargo.recargos.length
    && !_cargo.es_accesorio
    && !_cargo.convenios
    && _mutable && _tipoDeCargo.tipo_de_aplicacion === aplicacionesCargosEnum.CAPTURABLE;

    let _message = '';

    // if (_tipoDeCargo.tipo_de_aplicacion === aplicacionesCargosEnum.FIJO) {
    //   _message = 'No se puede recalcular un cargo de importe fijo.';
    // }
    if (_cargo.es_accesorio) {
      _message = 'No se puede recalcular un accesorio. El importe de este cargo depende de su cargo padre.';
    }
    if (_cargo.gastos.length) {
      _message = 'No se puede recalcular un cargo que ya generó gastos.';
    }
    if (_cargo.descuentos_especiales.length
      && _cargo.descuentos_especiales
        .some((d) => d.estados_globales === ESTADOS_GLOBALES_MAP.AUTORIZADO)) {
      _message = 'No se puede recalcular un cargo con descuentos autorizados.';
    }
    if (_cargo.saldado) {
      _message = 'No se puede recalcular un cargo saldado.';
    }
    if (_cargo.estados_globales === ESTADOS_GLOBALES_MAP.CANCELADO) {
      _message = 'No se puede recalcular un cargo cancelado.';
    }
    if (_cargo.estados_globales === ESTADOS_GLOBALES_MAP.AUTORIZADO) {
      _message = 'No se puede recalcular un cargo autorizado.';
    }
    if (_message) {
      message.warn(_message, 4);
    }

    setDisableImporteField(canEditCantidad);
    setCurrent(_cargo);
    setCurrentTipoDeCargo(_tipoDeCargo);
    setFormValues(_formValues);
    setMutable(_mutable);
    setTimeout(() => {
      formCargo.setFieldsValue(_formValues);
      form.setFieldsValue(padron);
    });
    if (_mutable
      && !(_cargo?.saldado
      || _cargo?.prescripto
      || _cargo?.motivo_de_cancelacion?.clave === 'PRESCRIPCION'
      || _cargo?.cancelado
      || _cargo?.abonado)) {
      setVisible(true);
    } else {
      message.info('No se pueden editar Cargos Cancelados, Abonados, prescriptos o en gastos de reporte moroso.');
      setSelectedRowKeys([]);
    }
    setLoading(false);
  };

  const filterData = () => {
    const { filter } = formFiltros.getFieldsValue();
    const key = filter || 1;
    const filtered = cargosFilter.current.filter(filters[key]);
    setTimeout(() => form.setFieldsValue(padron));
    setCargos(filtered);
    setSelectedRowKeys([]);
  };

  const onlyGetCargos = async (pdrn, key) => {
    setLoading(true);
    const tipo_de_padron = tipoDePadronSelected || pdrn.tipo_de_padron;
    const contentType = getContenTypePorTipoDePadron(tipo_de_padron);
    const params = { content_type: contentType, object_id: pdrn.id };
    const cargosPreFormat = await getCargosPaginados(params, true);
    const _cargos = normalizeCargos(sortCargos(cargosPreFormat));
    cargosFilter.current = _cargos;
    const padron_str = padrones.find((e) => e.id === tipo_de_padron)?.descripcion;
    const stringifyers = {
      1: ciudadanoToString,
      2: empresaToString,
      3: predioToString,
      4: vehiculoToString,
      15: contribuyenteToString,
      16: vehiculoToString,
      17: vehiculoToString,
      19: infraccionesToString,
      20: mercadosToString,
      25: infraccionesToString,
      31: panteonToString,
      32: mercadosToString,
    };
    const toString = stringifyers[tipo_de_padron] || restoDePadronesToString;
    const _nombre_completo = toString(pdrn);
    const _padron = {
      ...pdrn,
      _nombre_completo,
      padron_str,
      tipo_de_padron: tipoDePadronSelected,
    };
    if (key) {
      onClickEdit();
    }
    setTimeout(() => form.setFieldsValue(_padron));
    formFiltros.resetFields();
    setPadron(_padron);
    setCargos(_cargos);
    filterData();
    setLoading(false);
  };

  const handleSearchPadron = async () => {
    try {
      setLoading(true);
      const { q } = form.getFieldsValue();
      const dataPadron = await gettersPadronesCajaMap[tipoDePadronSelected]({ q });
      if ([0, 1].includes(dataPadron?.results?.length) || [1, 0].includes(dataPadron?.length)) {
        const found = dataPadron?.results?.[0] || dataPadron?.[0];
        if (found) {
          const match = cargos.find((item) => item.key === `${found.id}_${tipoDePadronSelected}`);
          if (!match) {
            await onlyGetCargos(found);
          }
        } else {
          message.warn('Padrón no encontrado', 3.5);
          setCargos([]);
          cargosFilter.current = [];
          setPadron();
        }
      } else {
        setDataExterno(dataPadron);
        setVisibleBusquedaPadrones(true);
        setCargos([]);
        cargosFilter.current = [];
        setPadron();
      }
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
    }
  };

  const onFinish = async () => {
    try {
      await form.validateFields();
      handleSearchPadron();
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'checkbox',
    onChange: () => {
      if (!selectedRowKeys.length) {
        const keys = cargos.map((item) => item.id);
        setSelectedRowKeys(keys);
      } else {
        setSelectedRowKeys([]);
      }
    },
  };

  const requiredRule = { required: true };

  const rules = {
    required: [requiredRule],
    requiredCancel: [
      requiredRule,
      {
        validator: async () => {
          const value = formCancel.getFieldValue('observaciones_de_cancelado');
          if (value?.length < 10) {
            throw new Error('Motivo demasiado corto');
          }
        },
      },
    ],
    fecha_inicial: [
      {
        validator: async (r, fecha_inicial) => {
          const { fecha_final } = formDescuento.getFieldsValue();
          if (fecha_final && (fecha_inicial?.isAfter(fecha_final)
            || fecha_final.format('DD/MM/YYYY') === fecha_inicial.format('DD/MM/YYYY'))) {
            throw new Error('El campo debe ser menor a Fecha Final');
          }
        },
      },
    ],
    fecha_final: [
      {
        validator: async (r, fecha_final) => {
          const { fecha_inicial } = formDescuento.getFieldsValue();
          if (fecha_inicial && (fecha_final?.isBefore(fecha_inicial)
            || fecha_final.format('DD/MM/YYYY') === fecha_inicial.format('DD/MM/YYYY'))) {
            throw new Error('El campo debe ser mayor a Fecha Inicial');
          }
        },
      },
    ],
    cantidad: [
      {
        required: !disableImporteField,
      },
      {
        validator: async () => {
          const val = formCargo.getFieldValue('importe');
          const value = typeof val === 'string' ? parseFloat(val) : val;
          if (value && currentTipoDeCargo?.tipo_de_aplicacion) {
            if (value > currentTipoDeCargo.importe_maximo) {
              throw new Error('El importe no puede ser mayor al importe máximo del tipo de cargo');
            } else if (value < currentTipoDeCargo.importe_minimo) {
              throw new Error('El importe no puede ser menor al importe mínimo del tipo de cargo');
            }
          }
        },
      },
    ],
  };

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      const clone = [...selectedRowKeys];
      clone.splice(selectedRowKeys.indexOf(record.id), 1);
      setSelectedRowKeys(clone);
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
    }
    setTimeout(() => {
      form.setFieldsValue(padron);
      formCargo.setFieldsValue({
        ...record,
        fecha_de_vencimiento: Moment(record?.fecha_de_vencimiento),
      });
    });
  };

  const onClear = () => {
    cargosFilter.current = [];
    setCargos([]);
    setDataExterno();
    setTipoDePadronSelected(padron_principal || padronesEnum.CIUDADANO);
    form.resetFields();
    formFiltros.resetFields();
    form.setFieldsValue({ padron: padron_principal || padronesEnum.CIUDADANO });
    setPadron();
    setSelectedRowKeys([]);
    setRestrict(false);
    setMutable(true);
  };

  const onCancelCargo = () => {
    formCargo.resetFields();
    setSelectedRowKeys([]);
    setVisible(false);
  };

  const FormBusqueda = () => (
    <Form
      layout="vertical"
      form={form}
      onFinish={() => onFinish()}
      scrollToFirstError
      initialValues={{ padron: tipoDePadronSelected }}
      className={padron ? 'without-feedback' : ''}
    >
      <Row gutter={10}>
        {!padron && (
          <>
            <Col
              xs={24}
              sm={24}
              md={8}
            >
              <Form.Item
                name="padron"
                label="Padrón"
                hasFeedback
                rules={rules.required}
              >
                <Select
                  onChange={setTipoDePadronSelected}
                  dataSource={padrones.filter((e) => e.id !== 5)}
                />
              </Form.Item>
            </Col>
            {tipoDePadronSelected && (
              <Col
                xs={24}
                sm={24}
                md={16}
              >
                <InputSearch
                  disabled={false}
                  label={padrones
                    .find((e) => e.id === tipoDePadronSelected)?.descripcion}
                  rules={rules.required}
                  tipoDePadron={tipoDePadronSelected}
                  callback={onlyGetCargos}
                  visibleBusquedaPadrones={visibleBusquedaPadrones}
                  setVisibleBusquedaPadrones={setVisibleBusquedaPadrones}
                  onChange={({ target: { value } }) => form.setFieldsValue({ q: value })}
                  onPressEnter={() => onFinish()}
                  title={getHelpTexts(tipoDePadronSelected)}
                  onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
                />
              </Col>
            )}
          </>
        )}
        {padron && !avilablePadrones.includes(tipoDePadronSelected) && (
          <>
            {([padronesEnum.CIUDADANO, padronesEnum.CONTRIBUYENTE]
              .includes(tipoDePadronSelected)) && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Clave"
                  name={tipoDePadronSelected === padronesEnum.CIUDADANO
                    ? 'clave_ciudadana' : 'clave'}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            )}
            {tipoDePadronSelected !== 16 && (
              <Col xs={24} sm={24} md={16}>
                <Form.Item
                  label={tipoDePadronSelected !== padronesEnum.VEHICULO
                    ? 'Nombre' : 'Placas/Serie'}
                  name="_nombre_completo"
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            )}
            {![padronesEnum.MOTOCICLETA, padronesEnum.VEHICULO, padronesEnum.LOTES_DE_PANTEON]
              .includes(tipoDePadronSelected) && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="RFC"
                  name={tipoDePadronSelected === padronesEnum.CONTRIBUYENTE ? 'rfc' : 'RFC'}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            )}
            {([padronesEnum.CIUDADANO, padronesEnum.CONTRIBUYENTE]
              .includes(tipoDePadronSelected)) && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="CURP"
                  name={tipoDePadronSelected === padronesEnum.CONTRIBUYENTE ? 'curp' : 'CURP'}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            )}
            {![padronesEnum.MOTOCICLETA, padronesEnum.VEHICULO, padronesEnum.LOTES_DE_PANTEON]
              .includes(tipoDePadronSelected) && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Correo"
                  rules={rules.email}
                  name={tipoDePadronSelected === padronesEnum.CONTRIBUYENTE
                    ? 'correo_electronico' : 'email'}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            )}
            {![padronesEnum.MOTOCICLETA, padronesEnum.VEHICULO, padronesEnum.LOTES_DE_PANTEON]
              .includes(tipoDePadronSelected) && (
              <LadaNumero
                rules={rules}
                form={form}
                names={{
                  lada: tipoDePadronSelected === padronesEnum.CONTRIBUYENTE
                    ? 'lada_celular' : 'lada',
                  numero_de_telefono: tipoDePadronSelected === padronesEnum.CONTRIBUYENTE
                    ? 'telefono_celular' : 'numero_de_celular',
                }}
                disabled
              />
            )}
            {tipoDePadronSelected === padronesEnum.VEHICULO && (
              <>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clase_del_vehiculo"
                    label="Clase"
                  >
                    <Select disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="servicio"
                    label="Servicio"
                  >
                    <Select
                      disabled
                      dataSource={serviciosVehiculares}
                      labelProp="nombre"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_vehiculo"
                    label="Tipo de Vehículo"
                  >
                    <Select
                      disabled
                      dataSource={tiposDeVehiculos}
                      labelProp="nombre"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="linea"
                    label="Línea"
                  >
                    <Select disabled />
                  </Form.Item>
                </Col>
              </>
            )}
            {tipoDePadronSelected === padronesEnum.MOTOCICLETA && (
              <>
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Clave"
                      name="clave"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Número de Placa"
                      name="numero_de_placa_vigente"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      name="serie"
                      label="Serie"
                      tooltip="Número de Serie de la Motocicleta"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Registro Publico"
                      name="registro_publico_vehicular"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Tarjeta de Circulación"
                      name="tarjeta_de_circulacion"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {tipoDePadronSelected === padronesEnum.REMOLQUE && (
              <>
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Clave"
                      name="clave"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Número de Placa"
                      name="numero_de_placa_vigente"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      name="serie"
                      label="Serie"
                      tooltip="Número de Serie del Remolque"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Registro Publico"
                      name="registro_publico_vehicular"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Tarjeta de Circulación"
                      name="tarjeta_de_circulacion"
                    >
                      <Input allowClear disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
        <Form.Item name="id" hidden>
          <Input disabled />
        </Form.Item>
      </Row>
      <Form.Item hidden>
        <Button htmlType="submit" />
      </Form.Item>
    </Form>
  );

  const onFinishCargo = async () => {
    try {
      await formCargo.validateFields();
      const values = formCargo.getFieldsValue();
      if (values.id) {
        const saved = await patchCargo(values.id, values);
        if (saved) {
          onCancelCargo();
          await onlyGetCargos(padron);
        }
      }
    } catch (err) {
      onError(err);
    }
  };

  const FormCargo = () => (
    <Form
      layout="vertical"
      form={formCargo}
      onFinish={() => onFinishCargo()}
      scrollToFirstError
    >
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="clave"
            label="Clave"
          >
            <Input disabled />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={16}>
          <Form.Item
            name="descripcion"
            label="Descripción"
            normalize={capitalize}
          >
            <Input.TextArea autoSize={{ minRows: 4, maxRows: 4 }} disabled />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <NumericInput
            name="importe"
            label="Importe Base"
            decimal
            disabled={!disableImporteField}
            rules={rules.cantidad}
            tooltip="Importe a cobrar"
          />
        </Col>
        <Col xs={24} sm={24} md={8}>
          <NumericInput
            name="importe_total"
            label="Cantidad"
            disabled
            decimal
          />
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="moneda"
            label="Moneda"
            hasFeedback
          >
            <Select
              dataSource={monedas}
              keyLabelRender
              disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="estados_globales"
            label="Estado"
          >
            <Select dataSource={estadosGlobales} disabled />
          </Form.Item>
        </Col>
        {currentTipoDeCargo?.fecha_de_creacion && (
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="fecha_de_creacion"
              label="Fecha de Creación"
            >
              <DatePicker
                format={DATE_FRONTEND_FORMAT}
                placeholder=""
                disabled
              />
            </Form.Item>
          </Col>
        )}
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="fecha_de_vencimiento"
            label="Fecha de Vencimiento"
          >
            <DatePicker
              format={DATE_FRONTEND_FORMAT}
              placeholder=""
              disabled={!currentTipoDeCargo?.es_editable_fecha_de_vencimiento}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="imprimir_observaciones"
            label="¿Imprimir Observaciones?"
            hasFeedback
          >
            <Select trueFalse />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={16}>
          <Form.Item
            name="observaciones_del_cargo"
            label="Observaciones"
          >
            <Input.TextArea autoSize={{ minRows: 4, maxRows: 4 }} />
          </Form.Item>
        </Col>
      </Row>
      {[aplicacionesCargosEnum.FORMULA].includes(currentTipoDeCargo.tipo_de_aplicacion) && (
        <Col span={24}>
          <Editor
            disabled
            variables={[]}
            form={formCargo}
            formItemLabel="Fórmula (Solo informativo)"
          />
        </Col>
      )}
      <Form.Item name="tipo_de_aplicacion" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="id" hidden>
        <Input disabled />
      </Form.Item>
      <Form.Item hidden>
        <Button htmlType="submit" />
      </Form.Item>
    </Form>
  );

  const getTitle = () => {
    if (visible) return 'Cargos';
    if (padron) return 'Padrón';
    return 'Búsqueda del Padrón';
  };

  const asignarEntidad = async (user) => {
    setLoading(true);
    const { razon_social } = _entidad;
    const { entidad, nombre_completo, id } = user;
    entidad.push(entidad.id);
    const edited = await patchCiudadano(
      id,
      { entidad },
      `Ahora el usuario ${nombre_completo} también pertenece a ${razon_social}.`,
    );
    if (edited) {
      await onlyGetCargos(edited);
    }
    setLoading(false);
  };

  const msgAsignarEntidad = (user) => (
    message.info({
      content: (
        <>
          <Row style={{ width: '100%' }}>
            El contribuyente no pertenece a la entidad.
          </Row>
          <Row justify="center">
            <strong style={{ marginRight: 3 }}>
              ¿Desea asignarlo a esta entidad?
            </strong>
          </Row>
          <Row align="middle" justify="center" style={{ width: '100%' }}>
            <Button
              type="link"
              onClick={() => asignarEntidad(user)}
            >
              Si
            </Button>
            <Button
              onClick={() => {
                message.destroy();
                form.resetFields();
              }}
              type="link"
            >
              No
            </Button>
          </Row>
        </>
      ),
      duration: 0,
    })
  );

  const onFinishCancel = async () => {
    try {
      setLoading(true);
      await formCancel.validateFields();
      const { observaciones_de_cancelado, motivo_de_cancelacion } = formCancel.getFieldsValue();
      const motivoSeleccionado = motivosDeCancelacion
        .find((motivo) => motivo.id === motivo_de_cancelacion);
      const values = {
        observaciones_de_cancelado,
        motivo_de_cancelacion,
        prescripto: motivoSeleccionado?.clave === 'PRESCRIPCION',
        cancelado: true,
        estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
        fecha_de_cancelado: new Moment().format(DATETIME_FORMAT),
        usuario_que_cancelo: usuario.id,
      };
      const promises = selectedRowKeys.map(
        (id) => patchCargo(id, values, true, padron?.clave, motivoSeleccionado?.clave),
      );
      const results = await Promise.all(promises);
      if (results?.length) {
        setVisibleCancel(false);
        message.info('Cargos Cancelados Correctamtene.');
        onCancelCargo();
        await onlyGetCargos(padron);
        formFiltros.resetFields();
        setTimeout(() => {
          filterData();
        });
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
      formCargo.setFieldsValue(formValues);
    }
  };

  const onRecalcular = async (id) => {
    setLoading(true);
    if (selectedRowKeys.length > 1) {
      message.warn('Solo puede recalcular un cargo a la vez.');
    } else if (selectedRowKeys.length === 1) {
      const key = id ?? selectedRowKeys[0];
      const cargo = cargos.find((e) => e.id === key);
      const _tipoDeCargo = await getTipoDeCargo(cargo.tipo_de_cargo.id);
      if (cargo.abonado) {
        setLoading(false);
        message.warn('No se puede recalcular un cargo abandonado.');
        return;
      }

      if (cargo.gastos.length) {
        setLoading(false);
        message.warn('No se puede recalcular un cargo que ya generó gastos.');
        return;
      }
      if (cargo.descuentos_especiales.length
      && cargo.descuentos_especiales
        .some((d) => d.estados_globales === ESTADOS_GLOBALES_MAP.AUTORIZADO)) {
        setLoading(false);
        message.warn('No se puede recalcular un cargo con descuentos autorizados.');
        return;
      }
      if (cargo.es_accesorio) {
        const cargoPadre = cargos.find((c) => c.id === cargo.cargo_padre);
        setLoading(false);
        message.warn({
          content: (
            <>
              <Row justify="center">
                <strong>
                  No se puede recalcular un cargo accesorio.
                </strong>
              </Row>
              <Row justify="center">
                <Col span={24}>
                  Para poder afectar el
                  importe de este accesorio se necesita recalcular su cargo padre
                </Col>
                <Col span={24}>
                  <strong>
                    (
                    {cargoPadre.descripcion}
                    )
                  </strong>
                </Col>
              </Row>
            </>
          ),
          duration: 5,
        });
        return;
      }
      if (cargo.saldado) {
        setLoading(false);
        message.warn('No se puede recalcular un cargo saldado.');
        return;
      }
      if (!isMutable(cargo)) {
        setLoading(false);
        message.warn('No se puede recalcular un cargo autorizado o cancelado.');
        return;
      }
      setCurrent({
        ...cargo,
        fecha_de_vencimiento_editable: _tipoDeCargo?.es_editable_fecha_de_vencimiento || false,
      });
      setVisibleModalCargos(true);
      setRecalcular(true);
    }
    setLoading(false);
  };

  const hasPermissionToAdd = permission.add && permission.hasAllViewPermission;

  const onClickCancel = () => {
    if (restrict) {
      message.warn('Este padrón tiene alertas restrictivas, no es posible cancelar cargos.');
      return;
    }

    setTimeout(() => formCargo.setFieldsValue(formValues));
    const selectedCargos = selectedRowKeys.map((key) => cargos.find((c) => c.id === key));
    if (selectedCargos.some((c) => c.estados_globales === ESTADOS_GLOBALES_MAP.INACTIVO)) {
      message.warn('No se pueden cancelar cargos con estado global inactivo.');
      return;
    }
    if (selectedCargos.some((c) => c.saldado)) {
      message.warn('No se pueden cancelar cargos Saldados.');
      return;
    }
    if (selectedCargos.some((c) => c.prescripto
      || c.motivo_de_cancelacion?.clave === 'PRESCRIPCION')) {
      message.warn('No se pueden cancelar cargos prescriptos.');
      return;
    }
    if (selectedCargos.some((c) => c.convenios
      && c.convenios.estados_globales === ESTADOS_GLOBALES_MAP.ACTIVO)) {
      message.warn('No se pueden cancelar cargos con convenios activos.');
      return;
    }
    if (selectedCargos.some((c) => c.cancelado)) {
      message.warn('No se pueden cancelar cargos Cancelados.');
      return;
    }
    if (selectedCargos.some((c) => c.tramite)) {
      message.warn('No se pueden cancelar cargos con tramite ligados.');
      return;
    }
    if (selectedCargos.some((c) => c.abonado)) {
      message.warn('No se pueden cancelar cargos abonados.');
      return;
    }
    if (selectedCargos.some((c) => c.tipo_de_cargo?.no_cargar_manualmente)) {
      message.warn('No se pueden cancelar cargos cargados manualmente.');
      return;
    }
    const cargosPadresSeleccionados = selectedCargos.filter((c) => !c.es_accesorio);
    const accesoriosNecesarios = cargosPadresSeleccionados
      .map((s) => cargos.filter((c) => c.es_accesorio && c.cargo_padre === s.id
      && !selectedRowKeys.includes(c.id))).flat();
    if (!accesoriosNecesarios.every((c) => selectedRowKeys.includes(c.id))) {
      const cargosPadresRequierenAccesorios = [...new Set(accesoriosNecesarios
        .map((c) => c.cargo_padre))]
        .map((id) => cargosPadresSeleccionados.find((c) => c.id === id));
      Modal.confirm({
        title: 'Accesorios',
        content: (
          <>
            <Typography.Text>
              No es posible continuar con su selección actual. Para proceder es necesario cancelar
              todos los accesorios de los cargos principales seleccionados.
              <br />
              Si continua serán cancelados también los accesorios a continuación:
            </Typography.Text>
            <br />
            <br />
            {cargosPadresRequierenAccesorios.map((cargo) => (
              <Col span={24} style={{ marginBottom: 20 }}>
                <b>
                  {cargo.tipo_de_cargo.periodo_fiscal?.periodo}
                  {' - '}
                  {cargo.descripcion}
                </b>
                {accesoriosNecesarios.filter((a) => a.cargo_padre === cargo.id).map((accesorio) => (
                  <Col span={24}>
                    {accesorio.tipo_de_cargo.periodo_fiscal?.periodo}
                    {' - '}
                    {accesorio.descripcion}
                  </Col>
                ))}
              </Col>
            ))}
          </>
        ),
        width: '60%',
        okText: 'Continuar',
        cancelText: 'Regresar',
        onOk: () => {
          setSelectedRowKeys([...selectedRowKeys, ...accesoriosNecesarios.map((a) => a.id)]);
          formCancel.resetFields();
          setTimeout(() => setVisibleCancel(true));
        },
      });
      return;
    }
    formCancel.resetFields();
    setVisibleCancel(true);
  };

  const onClickRestore = () => {
    const selectedCargos = selectedRowKeys.map((key) => cargos.find((c) => c.id === key));
    if (selectedCargos.some((c) => !c.cancelado)) {
      message.warn('Solo se pueden restaurar cargos cancelados.');
      return;
    }
    const modal = Modal.confirm({
      title: 'Restaurar cargos',
      content: '¿Seguro que desea restaurar los cargos seleccionados?',
      onOk: async () => {
        setLoading(true);
        modal.update({ cancelButtonProps: { disabled: true } });
        const restored = await postReactivarCargos({ cargos: selectedRowKeys });
        if (restored) await onlyGetCargos(padron);
        setLoading(false);
        modal.update({ cancelButtonProps: { disabled: false } });
      },
    });
  };

  const getControls = () => {
    if (!visible) {
      return [
        {
          text: 'Limpiar Búsqueda',
          icon: <DeleteOutlined />,
          onClick: onClear,
        }];
    }

    const controls = [
      {
        text: 'Regresar',
        icon: <ArrowLeftOutlined />,
        onClick: onCancelCargo,
        order: 2,
      },
    ];

    if (!disableImporteField && !current.convenios) {
      controls.push({
        text: 'Recalcular',
        icon: <ReloadOutlined />,
        onClick: () => onRecalcular(),
        disabled: selectedRowKeys.length !== 1,
        order: 1,
      });
    }

    if (mutable) {
      controls.push({
        text: 'Guardar',
        icon: <SaveOutlined />,
        onClick: () => onFinishCargo(),
        order: 3,
      });
    }

    return controls.sort((a, b) => a.order - b.order);
  };

  const onRowChildren = (record, keys) => {
    let cloneKeys = [...keys];
    const cargoChild = cargos.find((e) => e.cargo_padre === record.id && !e.es_accesorio);
    const cargosAccesorios = cargos.filter((e) => e.cargo_padre === record.id && e.es_accesorio);
    cloneKeys.push(record.id);
    cloneKeys = cloneKeys.filter((k) => !cargosAccesorios.map((e) => e.id).includes(k));
    cloneKeys = [...new Set(cloneKeys)];
    if (cargoChild) return onRowChildren(cargoChild, cloneKeys);
    return cloneKeys;
  };

  const onRowFather = (record, keys) => {
    let cloneKeys = [...keys];
    const cargoPadre = cargos.find((e) => (e.id === record.cargo_padre));
    const cargosAccesorios = cargos.filter((e) => e.cargo_padre === record.id && e.es_accesorio);
    cloneKeys.push(record.id);
    cloneKeys = cloneKeys.concat(cargosAccesorios.map((e) => e.id));
    cloneKeys = [...new Set(cloneKeys)];
    if (cargoPadre) return onRowFather(cargoPadre, cloneKeys);
    return cloneKeys;
  };

  const onRow = (record) => ({
    onClick: (e) => {
      e.stopPropagation();
      if (seleccionUnica) {
        handleOnRowClick(record);
        return;
      }
      const checked = selectedRowKeys.some((k) => k === record.id);
      const keys = seleccionPrevios
        ? onRowFather(record, checked ? [] : selectedRowKeys)
        : onRowChildren(record, checked ? [] : selectedRowKeys);
      setSelectedRowKeys(keys);
    },
  });

  return (
    <Row align="center" justify="center" className="container">
      <Spin
        tip="Cargando..."
        spinning={loading}
      >
        <Card
          className="form-container"
          title={getTitle()}
          bordered={false}
          extra={(
            <FormSubmitCustomControls
              loading={loading}
              controls={getControls()}
            />
          )}
        >
          {!visible && (
            <>
              <FormBusqueda />
              <InfoPadron padron={padron} tipoDePadron={tipoDePadronSelected} />
              <br />
              <Title level={4}>
                Cargos
              </Title>
              <Form
                layout="vertical"
                form={formFiltros}
                initialValues={{ filter: 3, seleccionUnica: true, seleccionPrevios: false }}
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Filtrar Por"
                      name="filter"
                    >
                      <Select dataSource={options} onChange={filterData} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Modo de selección"
                      name="seleccionUnica"
                    >
                      <Select trueFalse={['Única', 'Múltiple']} />
                    </Form.Item>
                  </Col>
                  {!seleccionUnica && (
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        label="Selección automática"
                        name="seleccionPrevios"
                      >
                        <Select trueFalse={['Cargos previos', 'Cargos posteriores']} />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </Form>
              <Table
                pageSize={20}
                cols={columns}
                data={cargos}
                rowSelection={rowSelection}
                handleOnRowClick={handleOnRowClick}
                allowSearch={false}
                rowKey="id"
                onRow={onRow}
                customActions={[
                  {
                    icon: <EditOutlined />,
                    text: 'Editar',
                    onClick: () => onClickEdit(),
                    disabled: selectedRowKeys.length !== 1 || !permission.hasAllViewPermission,
                    disabledBySelection: false,
                  },
                  {
                    text: 'Cancelar',
                    icon: <CloseCircleOutlined />,
                    className: 'danger',
                    onClick: onClickCancel,
                  },
                  {
                    text: 'Restaurar',
                    icon: <RollbackOutlined />,
                    onClick: onClickRestore,
                  },
                  {
                    icon: <PlusOutlined />,
                    text: 'Agregar Cargo',
                    onClick: () => {
                      if (restrict) {
                        message.warn('Este padrón tiene alertas restrictivas, no es posible agregarle cargos.');
                        return;
                      }
                      setCurrent({});
                      setRecalcular(false);
                      setTimeout(() => form.setFieldsValue(padron));
                      setVisibleModalCargos(true);
                    },
                    disabledBySelection: false,
                    disabled: !padron,
                    hasPermission: hasPermissionToAdd,
                  },
                ]}
                rowClassName={({ adeudo_total, es_accesorio, estados_globales }) => {
                  let className = '';
                  if (Number.isNaN(adeudo_total)) {
                    className += 'warn-row ';
                  }
                  if (estados_globales === ESTADOS_GLOBALES_MAP.CANCELADO) {
                    className += 'txtdec-line-throught';
                  }
                  if (!es_accesorio) {
                    className += ' bold';
                  }
                  return className;
                }}
                permission={permission}
              />
            </>
          )}
          {visible && (
            <FormCargo />
          )}
        </Card>
      </Spin>
      <ModalAgregarCargos
        visible={visibleModalCargos}
        onCancel={() => {
          setVisibleModalCargos(false);
          setTimeout(() => form.setFieldsValue(padron));
        }}
        padron={padron}
        callback={async (values) => {
          await onlyGetCargos(values);
          setVisible(false);
        }}
        _cargo={current}
        recalculate={recalcular}
      />
      <BusquedaAvanzadaPadrones
        visible={visibleBusquedaPadrones}
        setVisible={setVisibleBusquedaPadrones}
        callback={onlyGetCargos}
        dataExterno={dataExterno}
        setDataExterno={setDataExterno}
        tipoDePadron={tipoDePadronSelected}
        msgAsignarEntidad={msgAsignarEntidad}
      />
      <Modal
        visible={visibleCancel}
        footer={null}
        closable={false}
        title={(
          <FormSubmitCustomControls
            label="Cancelar"
            loading={loading}
            controls={[
              {
                onClick: () => setVisibleCancel(false),
                text: 'Regresar',
                icon: <ArrowLeftOutlined />,
              },
              {
                onClick: () => onFinishCancel(),
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
              },
            ]}
          />
        )}
      >
        <Form
          form={formCancel}
          layout="vertical"
          onFinish={onFinishCancel}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                name="motivo_de_cancelacion"
                rules={rules.required}
                label="Tipo de Movimiento"
                hasFeedback
              >
                <Select dataSource={motivosDeCancelacion} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="observaciones_de_cancelado"
                label="Motivo de cancelación"
                rules={rules.requiredCancel}
              >
                <Input.TextArea autoSize={{ minRows: 4, maxRows: 4 }} minLength={10} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item hidden>
            <Button htmlType="submit" />
          </Form.Item>
        </Form>
      </Modal>
      <ModalAlertas padron={padron} setRestrict={setRestrict} />
    </Row>
  );
};

export default Cargos;
